import React from 'react';
import { Button } from '../components/ui/button';
import { ArrowRight } from 'lucide-react';

const IntroSection = () => {
  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    contactSection?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <>
      <section className="intro-section">
        <div className="intro-container">
          <div className="intro-content">
            <div className="intro-text">
              <h2 className="section-title">About Dubai</h2>
              <p className="intro-description">
                Dubai is quietly emerging as one of the world's most exciting education hubs - a city that blends global exposure with real-world opportunity. Here, you can earn internationally recognized degrees from over 30 branch campuses of top-ranked universities, connect with students from over 150 nationalities, and start building your career even before you graduate.
              </p>
              <p className="intro-description">
                It's a place where innovation meets ambition, where scholarships, job opportunities, and world-class facilities are within reach. And the best part? Zero income tax. What truly sets Dubai apart is its unmatched quality of life, and inclusivity. Ranked among the top 10 safest cities in the world, it provides a secure, welcoming environment where students can focus on learning, growth, and exploration. Ready to take the next step or simply explore your options? Let's talk.
              </p>
              <div className="intro-button">
                <Button onClick={scrollToContact} className="intro-cta-primary">
                  Let's talk
                  <ArrowRight className="ml-2" size={20} />
                </Button>
              </div>
            </div>
            <div className="intro-image">
              <img 
                src="https://customer-assets.emergentagent.com/job_dubai-education/artifacts/wj4bd0ab_Graduation-cuate%20%281%29.png" 
                alt="Happy international students celebrating graduation after studying in Dubai universities"
                className="intro-illustration"
              />
            </div>
          </div>
        </div>
      </section>
      
      {/* Light Blue Wave Divider */}
      <div className="wave-divider">
        <svg viewBox="0 0 1200 120" preserveAspectRatio="none">
          <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" fill="#9fe2ff"></path>
        </svg>
      </div>
    </>
  );
};

export default IntroSection;
